export const CONTENT_TYPE = Object.freeze({
  UNDEFINED: "",
  LIVE: "live",
  HOSTED: "hosted",
  EXTERNAL: "external",
  MASTER: "master",
  AD_BREAK: "ad_break",
  FAST: "fast",
});

export const EXTERNAL_TYPE = Object.freeze({
  EMBEDDED: "embedded_player",
  STREAM: "stream",
});

// TODO: This should be imported as an external package shared with STF
export const EXTERNAL_SERVICE_TYPE = Object.freeze({
  YOUTUBE: "YOUTUBE",
  DAILYMOTION: "DAILYMOTION",
  ARTE: "ARTE",
  FACEBOOK: "FACEBOOK",
  VIMEO: "VIMEO",
  FRANCETV: "FRANCETV",
});

export const CHILD_CLASSIFICATIONS = Object.freeze({
  MAIN: "principal",
  TRAILER: "trailer",
  BONUS: "bonus",
  MAKING_OF: "making-of",
  VERSIONS: "versions",
});

export const SMARTLIST_TYPE = Object.freeze({
  STANDARD: "standard",
  AUTO: "auto",
});
